// extracted by mini-css-extract-plugin
export default {"inline":"l9r2H","container":"yaRQH","background":"f72Nv","word":"lllvn","number":"Ndm80"};